/* eslint-disable max-len */
import React from 'react';

// import DotsHorizontal from '@/components/commons/icons/DotsHorizontal';
import CloseIcon from '@/components/commons/icons/CloseIcon';
import ProfileImage from '@/components/commons/ProfileImage';
import { formattedCircle } from '@/components/my-sixty/contacts-game/helpers';

import { selectCircleIcon } from './helpers';
import style from './MyNetwork.module.css';

function ModalHeader({ setIsModalOpen, data }) {
    if (!data) {
        return null;
    }

    const formatedCircle = formattedCircle(data.effectiveCircle);

    return (
        <div className={`w-full flex flex-col-reverse md:flex-row items-start justify-between py-2 pl-2 pr-2 md:pr-0 md:py-6 md:pl-6 ${style.mountainBackground}`}>
            <div className="flex flex-col md:flex-row items-center justify-center md:justify-start w-full">
                <ProfileImage brief={data} height="h-[100px]" width="w-[100px]" externalStyles="mx-0" />
                <div className="ml2 md:ml-6 flex flex-col items-center md:items-start justify-center">
                    <p className="font-bold text-[20px]">{data.displayName}</p>
                    <p className="text-center md:text-left">{data.title}</p>
                    <div className="text-cleanSlate flex items-center pt-1">
                        <div className="pr-[8px]">
                            {selectCircleIcon(formatedCircle)}
                        </div>
                        {(formatedCircle) && <p>{`${formatedCircle} contact`}</p>}
                    </div>
                </div>
            </div>
            <div className="w-full md:w-min flex items-start justify-end px-1 md:px-0 md:mr-4">
                {/* <button
                    type="button"
                    data-tooltip-id="tip"
                    title="options"
                    aria-label="options"
                    className="border-[1px] border-cleanSlate rounded-lg flex items-center justify-center px-3 py-2"
                >
                    <DotsHorizontal className="w-3" />
                </button> */}
                <button
                    type="button"
                    data-tooltip-id="tip"
                    title="close"
                    aria-label="close"
                    onClick={() => setIsModalOpen(false)}
                    className="border-[1px] border-transparent rounded-lg flex items-center justify-center ml-0 md:ml-4 py-2 pt-[6px] mr-0"
                >
                    <CloseIcon className="w-4" />
                </button>
            </div>
        </div>
    );
}

export default ModalHeader;
